import React from 'react'
import style from './style.module.scss'
import PropTypes from 'prop-types'

const HItTracker = ({ totalHits }) => {
  const hits = [...(totalHits || '0000').toString()]
  return (
  <div className='d-flex flex-row gap-3'>
    {hits.map((hit, i) => {
      return (
        <div className={style.hitBG} key={i}>
          <span className={style.num}>{hit}</span>
        </div>
      )
    })}
  </div>
  )
}

HItTracker.propTypes = {
  totalHits: PropTypes.string
}

export default HItTracker
